import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { user } = useAuth();
  const [state, setState] = useState("verifying");
  const [message, setMessage] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) { setState("error"); setMessage("Saknar token."); return; }
    api.post("/auth/verify", { token })
      .then(() => {
        setState("ok");
        // refresh user so email_verified flag updates
        if (user) {
          api.get("/auth/me").then(() => window.dispatchEvent(new Event("storage")));
        }
      })
      .catch((e) => {
        setState("error");
        setMessage(e?.response?.data?.detail || "Verifieringen misslyckades.");
      });
  }, [params, user]);

  return (
    <div className="max-w-md mx-auto pt-6" data-testid="verify-page">
      <Card className="p-8 text-center bg-card">
        {state === "verifying" && (
          <>
            <Loader2 className="size-10 animate-spin mx-auto text-primary mb-3" />
            <p className="font-serif text-xl">Verifierar din e-post…</p>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 className="size-12 text-primary mx-auto mb-3" />
            <p className="font-serif text-2xl mb-2">E-post verifierad!</p>
            <p className="text-sm text-muted-foreground mb-5">Du kan nu posta i forumet.</p>
            <div className="flex gap-2 justify-center">
              <Button onClick={() => nav("/forum")} data-testid="verify-go-forum">Till forumet</Button>
              <Button variant="outline" onClick={() => nav("/profil")}>Min profil</Button>
            </div>
          </>
        )}
        {state === "error" && (
          <>
            <AlertCircle className="size-12 text-destructive mx-auto mb-3" />
            <p className="font-serif text-xl mb-2">Verifieringen misslyckades</p>
            <p className="text-sm text-muted-foreground mb-5">{message}</p>
            <Button onClick={() => nav("/profil")}>Be om ny länk</Button>
          </>
        )}
      </Card>
    </div>
  );
}
